export enum EBoardTab {
    DETAILS = 'DETAILS',
    ACTIVITY = 'ACTIVITY',
    ATTACHMENTS = 'ATTACHMENTS',
    BRANDING = 'BRANDING',
    BACKUPS = 'BACKUPS',
    EXPORT = 'EXPORT',
};
